import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { fetchAdminConfigs, updateAdminConfig } from '@/api/adminOps';
import { ADMIN_PAGE_SIZE } from '@/api/adminTypes';
import { parseApiErrorMessage } from '@/api/errors';
import { useAsyncData } from '@/hooks/useAsyncData';
import { AdminPageHeader } from '@/pages/admin/ui/AdminPageHeader';
import { AdminPagination } from '@/pages/admin/ui/AdminPagination';
import { useAdminToast } from '@/pages/admin/ui/AdminToast';
export function ConfigsPage() {
    const { show } = useAdminToast();
    const [page, setPage] = useState(0);
    const [tick, setTick] = useState(0);
    const [drafts, setDrafts] = useState({});
    const list = useAsyncData(['admin-configs', page, tick], () => fetchAdminConfigs(page, ADMIN_PAGE_SIZE));
    const items = list.data?.content ?? [];
    useEffect(() => {
        const rows = list.data?.content;
        if (!rows)
            return;
        setDrafts(Object.fromEntries(rows.map((item) => [item.id, item.value])));
    }, [list.data]);
    const save = async (id) => {
        try {
            await updateAdminConfig(id, drafts[id] ?? '');
            show('Сохранено');
            setTick((n) => n + 1);
        }
        catch (err) {
            show(parseApiErrorMessage(err, 'Не удалось сохранить'), 'danger');
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(AdminPageHeader, { title: "\u041A\u043E\u043D\u0444\u0438\u0433\u0438", subtitle: "\u0414\u0438\u043D\u0430\u043C\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F" }), _jsx("div", { className: "admin-table-wrap", children: _jsxs("table", { className: "admin-table", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "ID" }), _jsx("th", { children: "\u041A\u043E\u0434" }), _jsx("th", { children: "\u0422\u0438\u043F" }), _jsx("th", { children: "\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435" }), _jsx("th", {})] }) }), _jsx("tbody", { children: items.map((item) => {
                                const dirty = (drafts[item.id] ?? '') !== item.value;
                                return (_jsxs("tr", { children: [_jsx("td", { children: item.id }), _jsx("td", { children: item.name }), _jsx("td", { children: item.type }), _jsx("td", { children: _jsx("input", { className: "admin-input", value: drafts[item.id] ?? item.value, onChange: (event) => setDrafts((prev) => ({ ...prev, [item.id]: event.target.value })) }) }), _jsx("td", { children: _jsx("button", { type: "button", className: "admin-btn admin-btn-primary", disabled: !dirty, onClick: () => void save(item.id), children: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C" }) })] }, item.id));
                            }) })] }) }), _jsx(AdminPagination, { page: list.data?.page ?? page, totalPages: list.data?.totalPages ?? 0, onPageChange: setPage })] }));
}
